import { render, staticRenderFns } from "./Questions.vue?vue&type=template&id=05714267&scoped=true&"
import script from "./Questions.vue?vue&type=script&lang=js&"
export * from "./Questions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05714267",
  null
  
)

export default component.exports